import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("aPVyw"), parcelRequire.load("9f8mp"), parcelRequire.load("aNXiG"), parcelRequire.load("97gFA"), parcelRequire.load("h3v9b"), parcelRequire.load("jkk6G"), parcelRequire.load("k0Vga"), parcelRequire.load("lfyA4"), parcelRequire.load("b10RR"), parcelRequire.load("dZMz1"), parcelRequire.load("6n0X0"), parcelRequire.load("c0VSK")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("aPVyw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("aNXiG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("97gFA")} />
  <link rel="modulepreload" href={parcelRequire.resolve("h3v9b")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jkk6G")} />
  <link rel="modulepreload" href={parcelRequire.resolve("k0Vga")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lfyA4")} />
  <link rel="modulepreload" href={parcelRequire.resolve("b10RR")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dZMz1")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6n0X0")} />
  <link rel="modulepreload" href={parcelRequire.resolve("c0VSK")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
